import {Text} from '../../../atoms/Text/Text';
import {LabelBadge} from '../../../molecules/LabelBadge/LabelBadge';
import {LabelBadge16Type} from '../../../molecules/LabelBadge/LabelBadge16Type.enum';
import {LabelBadgeSizeType} from '../../../molecules/LabelBadge/LabelBadgeSizeType.enum';

export function NewsTitle({
  children,
  isPinned,
  isRestType,
  label,
  dateText,
}: {
  children: React.ReactNode;
  isPinned: boolean;
  isRestType: boolean;
  label?: string;
  dateText?: string;
}) {
  return (
    <div className="flex flex-col space-y-8pxr pt-18pxr">
      <div className="font-small1-bold flex items-center text-theme-solid-100 break-word-anywhere">
        <LabelBadge
          type={isPinned ? LabelBadge16Type.solid : LabelBadge16Type.line}
          sizeType={LabelBadgeSizeType.Size16}
          label={label}
          isRest={isRestType}
          className="mr-6pxr whitespace-nowrap"
        />
        {children}
      </div>
      <Text className="font-small2 text-theme-solid-100">{dateText}</Text>
    </div>
  );
}
